<template>
  <div v-if="hasGetTheLooks">
    <ComponentLoader :loading="getGetTheLookLoading"/>
    <GetTheLookHeader :use-as-separate="useAsSeparate"/>
    <swiper
        class="swiper"
        :navigation="true"
        :modules="modules"
        :space-between="30"
        :slides-per-view="1"
        :centered-slides="false"
        :pagination="{ clickable: true }"
    >

      <swiper-slide class="slide" v-for="stylisationSet in getTheLooks" :key="stylisationSet.id">
        <div class="q-row px-5 mb-5 q-bg-white get-the-look__gtl-container">
          <GetTheLook v-for="stylisation in stylisationSet.products" :key="stylisation.setNumber"
                      :product="stylisation" :use-as-separate="useAsSeparate"/>
        </div>
      </swiper-slide>
    </swiper>
    <SeeMoreButton v-if="useAsSeparate" :title="'Zobacz inne stylizacje >'"/>
  </div>
</template>
<script setup lang="ts">

import {onMounted, ref, defineProps, PropType} from 'vue'
import ComponentLoader from './ComponentLoader.vue'
import {Navigation, Pagination} from 'swiper/modules'
import {Swiper, SwiperSlide} from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import GetTheLook from '@/components/GetTheLook/GetTheLook.vue'
import {storeToRefs} from 'pinia'
import {useGetTheLookStore} from '@/store/getTheLookStore'
import GetTheLookHeader from '@/components/GetTheLook/GetTheLookHeader.vue'
import SeeMoreButton from "@/components/SeeMoreButton.vue";

defineProps({
  useAsSeparate: {
    type: Boolean as PropType<boolean>,
    default: true
  }
});

const modules = ref([Pagination, Navigation])

const getTheLookStore = useGetTheLookStore()

const {getTheLooks, getGetTheLookLoading, hasGetTheLooks} = storeToRefs(getTheLookStore)

onMounted(async () => {
  await getTheLookStore.fetchGetTheLooks()
})

</script>

